<template>
    <div class="notification-wrapper mr-2">
        <!-- Notification Icon -->
        <div class="notification-icon" @click="togglePopover">
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="#662d91" d="M10 21h4c0 1.1-.9 2-2 2s-2-.9-2-2m11-2v1H3v-1l2-2v-6c0-3.1 2-5.8 5-6.7V4c0-1.1.9-2 2-2s2 .9 2 2v.3c3 .9 5 3.6 5 6.7v6zm-4-8c0-2.8-2.2-5-5-5s-5 2.2-5 5v7h10z"/></svg>            <!-- <i class="icon-star"></i> -->
            <span v-if="unreadCount > 0" class="notification-count">{{ unreadCount }}</span>
        </div>

        <!-- Popover -->
        <transition name="fade-popover">
    <div v-if="isPopoverOpen" class="popover show">
        <div class="p-2 border-bottom d-flex justify-content-between">
            <h4 class="m-0">Notifications</h4>
        
            <b-button @click="closePopover" class="text-center" variant="link" style="min-width: 25px !important; width: 25px; height: 25px; padding: 0;">
                <i class="icon-close" style="font-size: 20px;"></i>
            </b-button>
        </div>
        <ul style="height: 258px;overflow-y: auto;">
            <li v-for="(notification, index) in notifications" :key="index" :class="{ 'unread': !notification.read }">
                <a @click="openDetails({notification})" class="w-100 text-decoration-none">
                    <div class="notification-details d-flex">
                        <img :src="notification.icon" alt="icon" class="notification-icon-small" />
                        <div class="notification-title">{{ notification.title }}</div>
                    </div>
                    <div class="notification-time float-right">{{ formatTime(notification.createdAt) }}</div>
                </a>
            </li>
        </ul>
    </div>
</transition>
 <notification-details-popup
                title="Notification"
                :description=selectedDescription
                 >
        </notification-details-popup>
    </div>

   

</template>

<script>
import request from '@/utils/request'
import NotificationDetailsPopup from './popups/NotificationDetailsPopup.vue';

    export default {
        components: {NotificationDetailsPopup},
        data() {
            return {
                isPopoverOpen: false,
                notifications: [],
                selectedDescription:null
            };
        },
        computed: {
            unreadCount() {
                return this.notifications.filter(notification => !notification.read).length;
            }
        },
        mounted() {
            this.fetchNotifications(); // Fetch notifications when the component is mounted
        },
        methods: {
            openDetails(data)
            {
                data=data.notification
                this.markAsRead(data)
                if(data.category=='external')
            {
                window.open(data.description, "_blank");
            }
            else
            {
                this.selectedDescription=data.description
                this.$bvModal.show('notification-details-popup')
            }
            },
            async fetchNotifications() {
                try {
                    let {data} = await request({url: `/configurations/notifications`})
                    if(data && data.data && data.data.length )
                {
                    this.notifications = data.data;
                }
                } catch (error) {
                    console.error('Error fetching notifications:', error);
                }
            },
            async markAsRead(notification,markAllRead=false) {
      try {
        await request.post(`configurations/notifications`,{notificationId:notification._id,markAllRead:markAllRead});
        notification.read = true; // Update the local state to reflect that the notification is read
      } catch (error) {
        console.error('Error marking notification as read:', error);
      }
    },
            togglePopover() {
                this.isPopoverOpen = !this.isPopoverOpen;
            },
            closePopover() {
                this.isPopoverOpen = false;
            },
            formatTime(date) {
                const now = new Date();
                const diffInSeconds = Math.floor((now - new Date(date)) / 1000);

                if (diffInSeconds < 60) {
                    return `${diffInSeconds} seconds ago`;
                } else if (diffInSeconds < 3600) {
                    const minutes = Math.floor(diffInSeconds / 60);
                    return `${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
                } else if (diffInSeconds < 86400) {
                    const hours = Math.floor(diffInSeconds / 3600);
                    return `${hours} hour${hours !== 1 ? 's' : ''} ago`;
                } else {
                    return new Date(date).toLocaleDateString();
                }
            }
        }
    };
</script>

<style scoped>
.fade-popover-enter-active, .fade-popover-leave-active {
  transition: opacity 0.3s ease-in-out;
}

.fade-popover-enter, .fade-popover-leave-to {
  opacity: 0;
}

    .notification-wrapper {
        position: relative;
        display: inline-block;
    }

    .notification-icon {
        cursor: pointer;
        position: absolute;
        font-size: 24px;
    }

    .notification-count {
        background: red;
        color: white;
        border-radius: 50%;
        padding: 2px 5px;
        position: absolute;
        top: -5px;
        right: -5px;
        font-size: 12px;
    }

    .popover {
        position: absolute;
        right: 0;
        left: -250px;
        top: 30px;
        width: 300px;
        background: white;
        border: 1px solid #ddd;
        border-radius: 5px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        z-index: 1000;
        border-radius: 10px;
    }

    .popover-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
        border-bottom: 1px solid #ddd;
        background-color: var(--primary-color);
    }

    .popover-header h4 {
        margin: 0;
        color: #fff;
    }

    ul {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    li {
        display: flex;
        align-items: center;
        padding: 10px;
        border-bottom: 1px solid #f0f0f0;
    }

    li.unread {
        background-color: #f9f9f9;
        font-weight: bold;
    }

    .notification-icon-small {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 10px;
    }

    .notification-details {
        flex-grow: 1;
        /* display: flex; */
        align-items: end;
    }

    .notification-title {
        font-size: 14px;
        margin-bottom: 5px;
    }

    .notification-time {
        font-size: 12px;
        color: #999;
    }
</style>
